var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0C14.3289 0 0 14.3289 0 32C0 49.6711 14.3289 64 32 64C49.6711 64 64 49.6711 64 32C64 14.3289 49.6711 0 32 0ZM32 59.4286C16.8737 59.4286 4.57143 47.1264 4.57143 32C4.57143 16.8737 16.8737 4.57143 32 4.57143C47.1264 4.57143 59.4286 16.8737 59.4286 32C59.4286 47.1264 47.1264 59.4286 32 59.4286Z",
    fill: "#E3332A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7579 21.2419C41.864 20.3479 40.4164 20.3479 39.5275 21.2419L31.9999 28.7695L24.4722 21.2419C23.5783 20.3479 22.1307 20.3479 21.2418 21.2419C20.3478 22.1359 20.3478 23.5835 21.2418 24.4724L28.7694 32L21.2418 39.5276C20.3478 40.4216 20.3478 41.8692 21.2418 42.7581C21.6887 43.2051 22.2729 43.4286 22.857 43.4286C23.4411 43.4286 24.0253 43.2051 24.4722 42.7581L31.9999 35.2305L39.5275 42.7581C39.9745 43.2051 40.5586 43.4286 41.1427 43.4286C41.7268 43.4286 42.311 43.2051 42.7579 42.7581C43.6519 41.8641 43.6519 40.4165 42.7579 39.5276L35.2303 32L42.7579 24.4724C43.6519 23.5784 43.6519 22.1308 42.7579 21.2419Z",
    fill: "#E3332A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorOutlined);
export default __webpack_public_path__ + "static/media/error-outlined.4f18a43fe6081983d21febf58c5d43eb.svg";
export { ForwardRef as ReactComponent };